
























import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalProjectProcessMonitoring",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalProjectProcessMonitoring extends Vue {
  get fetchData() {
    return api.externalProjectProcessMonitoringService.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalProjectProcessMonitoring-detail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
